<template>
  <div class="overall-situation">
    <div class="registerList">
      <div class="topBox">
        <span class="topTitle">版权转让</span>
      </div>
      <div class="medium">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="toRagister">新建转让</el-button>
      </div>
      <el-table :data="tableData" :stripe="true">
        <el-table-column prop="batchNo" label="批次号"></el-table-column>
        <el-table-column prop="batchName" label="批次名称" width="260"></el-table-column>
        <el-table-column prop="createTimes" label="创建时间"></el-table-column>
        <el-table-column prop="authStatus" label="转让进度">
          <template slot-scope="scope">
            <p class="authStatus">
              <i :style="{background: scope.row.examineStatus<3?'#F1C325':(scope.row.examineStatus<4?'green':'red')}"></i>
              {{scope.row.examineStatus > 0?examineList.filter(val => {return val.code==scope.row.examineStatus})[0].label:statusList.filter(val => {return val.code==scope.row.authStatus})[0].label}}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="batchName" label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.examineStatus == 4 && scope.row.role == 1" @click="editDetails(scope.row)">编辑</el-button>
            <el-button type="text" v-if="scope.row.examineStatus == 4 || scope.row.examineStatus == 0 " @click="deletetchNo(scope.row)">删除</el-button>
            <el-button type="text" v-if="scope.row.examineStatus == 0" @click="todoDetails(scope.row)">编辑</el-button>
            <el-button type="text" v-if="scope.row.examineStatus == 1 || scope.row.examineStatus == 2" @click="toDetails(scope.row)">详情</el-button>
            <el-button type="text" v-if="scope.row.examineStatus == 3" @click="toGoods(scope.row)">查看作品</el-button>
            <el-button type="text" v-if="scope.row.examineStatus == 4 && scope.row.role == 2" @click="toDetails(scope.row, 0)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="query.currentPage"
        :page-sizes="[15, 30, 50, 100]"
        :page-size.sync="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="textAlign: right; marginTop:10px; marginBottom: 10px">
      </el-pagination>
      <el-dialog
        title="转让作品"
        :visible.sync="dialogVisible"
        width="55%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center>
        <!-- <span>这是一段信息</span> -->
        <transferenceGoods :ttopno = "ttopno"> </transferenceGoods>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import transferenceGoods from './transferenceGoods.vue'
import { getRegisterList, deletebatchNo } from '@/api/register'
export default {
  components:{
    transferenceGoods
  },
  data(){
    return{
      tableData: [],
      ttopno:'',
      dialogVisible: false,
      query: {
        type: '3',
        usn: '',
        currentPage: 1,
        pageSize: 15
      },
      statusList:[{
        code: 1,
        label: '待确认',
        color: '#F1C325'
      },{
        code: 2,
        label: '已确认',
        color: '#F1C325'
      },{
        code: 3,
        label: '已取消',
        color: '#F1C325'
      },{
        code: 4,
        label: '完成',
        color: '#43AF62'
      }],
      examineList:[{
        code: 0,
        label: '未提交',
        color: '#F1C325'
      },{
        code: 1,
        label: '等待审核',
        color: '#F1C325'
      },{
        code: 2,
        label: '审核中',
        color: '#F1C325'
      },{
        code: 3,
        label: '审核通过',
        color: '#43AF62'
      },{
        code: 4,
        label: '审核失败',
        color: 'red'
      },{
        code: 5,
        label: '证书生成中',
        color: 'red'
      }],
      total: 0
    }
  },
  created(){
    // if (this.$route.query.usn) {
    //   sessionStorage.setItem('usn', this.$route.query.usn)
    // }
    this.userData = this.$store.state.userData;
    this.batchNo = this.$route.query.batchNo || ''
    // this.query.usn = sessionStorage.getItem('usn')
    // this.getTableData()
    if(this.userData.usn){
      this.getTableData()
    }else{
      this.$router.push({
          path: "/login"
        });
    }
  },
  methods:{
    handleSizeChange(val){
      this.query.pageSize = val;
      this.getTableData()
    },
    handleCurrentChange(val){
      this.query.currentPage = val;
      this.getTableData()
    },
    toDetails(item, flag=1){
      this.$router.push({
        path: '/transferencecttration',
        query: {
          step: 4,
          batchNo: item.batchNo,
          role: item.role,
          showTitle: flag
        }
      })
    },
    deletetchNo(item) {
      let fd = new FormData()
      fd.append('batchNo', item.batchNo) 
      deletebatchNo(fd).then(res=>{
        if (res.code === 200) {
          this.getTableData()
          // this.tableData = res.data.list
          // this.total = res.data.page.totalPage
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    editDetails(item){
      this.$router.push({
        path: '/transferencecttration',
        query: {
          step: 1,
          batchNo: item.batchNo,
          role: item.role
        }
      })
    },
    todoDetails(item){
      let stepNum = 0
      if (item.authStatus == '3' && item.role == 1) {
        stepNum = 1
      } else {
        stepNum = (item.authStatus == '2' ? 3 : 2)
      }
      this.$router.push({
        path: '/transferencecttration',
        query: {
          step: stepNum,
          batchNo: item.batchNo,
          role: item.role
        }
      })
    },
    toGoods(item){
      this.ttopno = item.batchNo
      this.dialogVisible = true
      // this.$router.push({
      //   path: '/transferenceGoods',
      //   query: {
      //     batchNo: item.batchNo
      //   }
      // })
    },
    getTableData(){
      let fd = new FormData()
      fd.append('usn', this.userData.usn) 
      fd.append('type', this.query.type) 
      fd.append('currentPage', this.query.currentPage) 
      fd.append('pageSize', this.query.pageSize) 
      getRegisterList(fd).then(res=>{
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.page.totalPage
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    toRagister(){
      // if (!this.$parent.usnInfo || !(this.$parent.usnInfo.user.identityAuthentication == '2')){
      //   this.$message({
      //     message: '请先实名认证',
      //     type: 'warning'
      //   })
      //   return
      // }
      const userData = this.$store.state.userData
      if (userData.identityAuthentication != '2') {
        this.$message({
          message: '请先实名认证',
          type: 'warning'
        })
        this.$router.push({
          path: "/myAccount/userInfo/1"
        });
        window.sessionStorage.setItem("path", '/myAccount/userInfo/1');
        return
      }
      // if(this.userData.usn){
        this.$router.push({
          path: '/transferencecttration',
        });
      // }else{
        // this.$router.push({
        //   path: "/login"
        // });
      // }
      // this.$router.push({
      //   path: '/transferencecttration'
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.overall-situation{
  // margin-top: 20px;
  padding-bottom: 50px;
  padding-top: 20px;
}
.authStatus{
  display: flex;
  align-items: center;
  i{
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 8px;
    border-radius: 4px;
  }
}
::v-deep .medium .el-button--primary{
    width: 102px !important;
    height: 31px !important;
    background: #1C77FF !important;
    border: 1px solid #1C77FF !important;
    opacity: 1;
    // span{
    //   position: relative;
    //   top: -10px;
    //   left: 0px;
    //   font-size: 13px;
    //   margin: 0 auto;
    //   color: #FFFFFF;
    //   text-align: center;
    //   line-height: 28px;
    //   img{
    //     width: 12px;
    //     height: 12px;
    //     // margin-top: 1px;
    //   }
    // }
  }
.registerList{
  margin: 0 auto;
  margin-top: 20px;
  min-width: 1200px;
  max-width: 1200px;
  padding-top: 57px;
  padding: 20px;
  background: #FFFFFF;
  .topBox{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
    margin-bottom: 33px;
    padding-left: 26px;
    background: url('../../../../assets/icon.png') no-repeat left center;
    background-size: 20px 20px;
  }
  .medium{
    text-align: right;
    font-size: 12px;
    margin-bottom: 20px;
  }
}
</style>